import { QuoteLabel } from 'components/common-form/sidePanel/backTest/QuoteLabel';
import { INITIAL_QUOTE_LABEL, SECOND_QUOTE_LABEL } from 'components/common-form/sidePanel/backTest/shared';
import { ErrorWithRetry } from 'components/shared/ErrorWithRetry';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import type { BackTestModel } from 'state/backTest/backTest.model';

export type BackTestErrorProps = {
  hasError: boolean;
  retryTest: () => void;
} & Pick<BackTestModel, 'errors' | 'requestedQuoteIds'>;

export function BackTestError({ hasError, retryTest, errors, requestedQuoteIds }: BackTestErrorProps) {
  const isInternal = !useIsInternalUser();
  const { formatMessage } = useIntl();
  let errorsMsg: ReactNode | undefined;
  if (errors) {
    errorsMsg = (
      <>
        {Object.entries(errors).map(([quoteId, { message, status }]) => {
          let errorMessage;
          if (status === 'INTERNAL') {
            errorMessage = isInternal ? message : formatMessage({ id: 'backTest.generic.error.message' });
          } else {
            errorMessage = message;
          }
          return (
            <div key={quoteId} className="d-flex w-100 align-items-center">
              <QuoteLabel
                shortLabel={quoteId === requestedQuoteIds.initialQuoteId ? INITIAL_QUOTE_LABEL : SECOND_QUOTE_LABEL}
                color={quoteId === requestedQuoteIds.initialQuoteId ? 'primary' : 'danger'}
                className="me-1"
              />
              {errorMessage}
            </div>
          );
        })}
      </>
    );
  }

  if (hasError || errorsMsg) {
    return (
      <ErrorWithRetry severity="danger" onRetry={retryTest} msgKey="backTest.generic.error.message" msg={errorsMsg} />
    );
  }
  return <></>;
}
